
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as AddContextIconComponent } from "./add-context-icon.svg";

export const AddContextIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <AddContextIconComponent {...props} />;
};
